import React, { useCallback, useMemo, useState } from "react"

const defaultState = {
  setCaptcha: () => {},
  getCaptcha: () => false,
}

const CaptchaContext = React.createContext(defaultState)

const CaptchaProvider = ({ children }) => {
  const [captchaValue, setCaptchaValue] = useState(false)

  const setCaptcha = useCallback((value) => {
    setCaptchaValue(Boolean(value))
  }, [])

  const getCaptcha = useCallback(() => {
    return captchaValue
  }, [captchaValue])

  const contextValue = useMemo(() => {
    return {
      getCaptcha,
      setCaptcha,
    }
  }, [getCaptcha, setCaptcha])

  return (
    <CaptchaContext.Provider value={contextValue}>
      {children}
    </CaptchaContext.Provider>
  )
}

export default CaptchaContext
export { CaptchaProvider }
